import { render, staticRenderFns } from "./app-tabbar.vue?vue&type=template&id=51511e5c&scoped=true&"
import script from "./app-tabbar.vue?vue&type=script&lang=js&"
export * from "./app-tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51511e5c",
  null
  
)

export default component.exports